import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {DurationFormat, TemporalFormatering} from "../tjenester/TemporalFormatering";
import {lesDurationSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import {DurationSerialisert} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import Duration = Temporal.Duration;

/** Formaterer Duration instanser.
 *
 * Angitt varighet kan være av typen Duration, DurationSerialisert
 * Format kan angis som argument nr 2,
 * 'timerMinutterStandard' gir '1:20 timer', 'timerMinutterKort' gir '1:20 t'.
 * 'timerMinutterSekunderStandard' og 'timerMinutterSekunderKort' viser i tillegg sekunder dersom varigheten er under 1 time,
 * eks '2:05 minutter', '45 sekunder' og '2:05 min', '45 sek'.
 *
 * Eksempler:
 * `{{ enVarighet|duration:'timerMinutterStandard' }}`
 *
 * Se tester TemporalFormatering.jestspec.ts for eksempler på ulike formater.
 */
@Pipe({name: 'duration', pure: true, standalone: true})
export class FormaterDurationPipe implements PipeTransform {

    constructor(private formatering: TemporalFormatering) {
    }

    transform(varighet: Duration | DurationSerialisert | null, format: DurationFormat = 'timerMinutterStandard'): string {
        return this.formatering.formaterDuration(
          (varighet instanceof Duration) ? varighet : lesDurationSerialisertOpt(varighet),
          format);
    }
}

